import {isProd} from "@qoohoo/common/constants/isProd";
import {entity_or_creator} from "./configs/staging/entity_or_creator";
import {creator_J6HQUDIB} from "./configs/production/creator_J6HQUDIB";

const configsProductionByCreator =  {
  // 'J6HQUDIB': creator_J6HQUDIB
}

const configsProductionByEntity =  {}

const configsStagingByCreator =  {
  'MW2F6JH1': entity_or_creator
}

const configsStagingByEntity =  {
  '7EB6G1G1': entity_or_creator,
  '9H3A4K50': entity_or_creator,
}

export const getCustomUserForm = (entityId, creatorId) =>  {
  if(!entityId) {
    return null;
  }

  let config;

  const creatorConfig = isProd ? configsProductionByCreator[creatorId.toUpperCase()] : configsStagingByCreator[creatorId.toUpperCase()];
  const entityConfig = isProd ? configsProductionByEntity[entityId.toUpperCase()] : configsStagingByEntity[entityId.toUpperCase()];

  config = entityConfig || creatorConfig;

  return (config || null);
}
